import { getUserIdFromAuth } from './AuthSelector';
import { createSelector } from 'reselect';
export const getSsoRequired = state => state.sso.required;
export const getSsoExemptUsers = state => state.sso.exemptUsers;
export const getCanShowPasskeys = createSelector([getSsoRequired, getUserIdFromAuth, getSsoExemptUsers], (ssoRequired, userId, exemptUsers) => !ssoRequired || ssoRequired && exemptUsers.includes(userId));